<template lang="pug">
	header#header(:class="{'ativo': ativo}")
		.wrapper
			.logo 
				router-link(:to="{name: 'Home'}")
					SvgIcon(data="@svgs/mind-service.svg", original)
			ul.items
				li.item(@click="closeMenu()")
					router-link(:to="{name: 'Home'}")
						span A MIND
				li.item(@click="closeMenu()") 
					router-link(:to="{name: 'Servicos'}")
						span SERVIÇOS
				li.item(@click="closeMenu()") 
					router-link(:to="{name: 'Cases'}")
						span CASES
				li.item(@click="closeMenu()") 
					router-link(:to="{name: 'Equipe'}")
						span EQUIPE
				li.item(@click="closeMenu()") 
					router-link(:to="{name: 'Contato'}")
						span CONTATO
			button(@click="toggleMenu()").menu
				i.first
				i.second
				i.third
</template>

<script>
export default {
  	name: 'component-header',
	data() {
		return {
			ativo: false
		}
	},
	methods: {
		toggleMenu(){
			this.ativo = !this.ativo
		},
		closeMenu() {
			this.ativo = false
		}
	}
}
</script>

<style lang="stylus" scoped src="./Header.styl"></style>
